import AdendumSPK from "./AdendumSPK";

export default AdendumSPK;
